import { initializeApp } from 'firebase/app'
import type { User } from 'firebase/auth'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'
import { userLogout } from '~/scripts/auth/applicationAuth'
import { initializeSnowflakeQueries } from '~/scripts/snowflake/initializeSnowflake'

// import { getAnalytics } from 'firebase/analytics'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()

  let firebaseConfig = config.public.FIREBASE_WEBAPP_CONFIG as any
  // If firebaseConfig is a string, parse it
  if (typeof firebaseConfig === 'string') firebaseConfig = JSON.parse(firebaseConfig)
  console.log('Firebase Config:', firebaseConfig)

  const app = initializeApp(firebaseConfig)

  // const analytics = getAnalytics(app);
  const auth = getAuth(app)
  const firestore = getFirestore(app)
  const functions = getFunctions(app)

  // //////////////////////////////////////////////////////////////////
  // Watches Authentication State
  // //////////////////////////////////////////////////////////////////
  const user = useState<User | null>('user', () => null)

  // //////////////////////////////////////////////////////////////////
  // 💬 Watch Authentication & Data Initialization
  // //////////////////////////////////////////////////////////////////
  const userCookie = useCookie('user', { maxAge: 180 * 60 })

  // const { $auth } = useNuxtApp()
  const { syncAccountProfile, syncUserProfile, alertSnackbar } = useGlobalsStore()

  // Watches For Changes in User Authentication State
  onAuthStateChanged(auth, (authUser) => {
    console.log('Auth User:', authUser)

    // Checks Global accountId
    const { accountId, userId } = storeToRefs(useGlobalsStore())

    // If Authenticated and Data is Needed
    // If Account ID is null then get sync data
    if (!accountId.value && authUser) {
      // TODO: Temp Measure To Change AccountId: 1 => AccountId: 1712000000000
      accountId.value = authUser.displayName
      userId.value = authUser.uid
      if (authUser.displayName === '1') accountId.value = '1712000000000'

      // Set Auth Cookie
      userCookie.value = JSON.stringify({ uid: authUser.uid, email: authUser.email })
      console.log('User Successfully Logged In', authUser)
      if (accountId.value) initializeGlobalData(accountId.value, authUser.uid)
    }

    // If Not Authenticated and Data Should be Cleared
    if (accountId.value && !authUser) {
      console.warn('Snowflake Has Logged You Out. Please Log In Again.')
      alertSnackbar('Snowflake Has Logged You Out. Please Log In Again.', 'error', 5000)
      userLogout()
    }
  })

  // //////////////////////////////////////////////////////////////////
  // 💬 Data Initialization - If User is Authenticated
  // //////////////////////////////////////////////////////////////////
  function initializeGlobalData(accountId: string, uid: string) {
    // Subscribe to the Account and User Profile Docs From Firestore
    syncAccountProfile(accountId)
    syncUserProfile(accountId, uid)

    // Initialize Snowflake Queries - currentRole, currentWarehouse, etc.
    initializeSnowflakeQueries()
  }

  // If Using Local Cloud Function Emulation (on port 5001)
  // Args in launch.json file
  // Must pnpm run serve on functions project
  if (config.public.USE_FUNCTION_EMULATION) {
    console.log('Using Local Cloud Function Emulation on 127.0.0.1 Port 5001')
    connectFunctionsEmulator(functions, '127.0.0.1', 5001)
  }

  // nuxtApp.vueApp.provide('auth', auth)
  // nuxtApp.provide('auth', auth)

  // nuxtApp.vueApp.provide('firestore', firestore)
  // nuxtApp.provide('firestore', firestore)

  // nuxtApp.vueApp.provide('cloudFunctions', functions)
  // nuxtApp.provide('cloudFunctions', functions)
  return {
    provide: {
      auth,
      firestore,
      cloudFunctions: functions,
      user,
    },
  }
})
